import { all, takeLatest, put, call, select, take, delay, race, fork } from "redux-saga/effects";
import { toast } from 'react-hot-toast';
import usersSearchSlice, { filterUsers, loadUsers, selectUsersSearchGridParams, selectUsersSearchIsBusy } from "./slice";
import { UsersResponse, UsersSearchResponse } from "../../../api/types";
import { IConfiguration } from "../../../shared/types";
import { selectConfig } from "../../../shared/redux/slice";
import { selectIdToken, unauthorized } from "../../../auth/redux/slice";
import { SimplyTestApi } from "../../../api/simplytest";
import { AxiosResponse } from "axios";
import { loadUser } from "../../add-edit/redux/slice";
import { UsersGridParams } from "../types";

export abstract class UsersSagas {
    public static* run() {
        try {
            yield all([
                fork(UsersSagas.debounceFilterUsers),
                takeLatest(loadUsers, UsersSagas.loadUsers),
            ]);
        }
        catch(e: any){
            toast.error('Unable to register Users module.');
            console.log(`[UsersSagas:run] the following exception has occurred`, e);
        }
    }

    public static* loadUsers(action: ReturnType<typeof loadUsers>){
        const isLoading: boolean = yield select(selectUsersSearchIsBusy);
        try {
            if(!isLoading)
                yield put(usersSearchSlice.actions.setState('BUSY'));
            
            const gridParams: UsersGridParams = yield select(selectUsersSearchGridParams);
            const config: IConfiguration = yield select(selectConfig);
            const idToken: string = yield select(selectIdToken);
            
            var client = new SimplyTestApi(config.apiBaseUrl, idToken);
            const usersResponse: AxiosResponse<UsersSearchResponse> = yield call(
                {
                    context: client,
                    fn: client.searchUsers
                },
                {
                    ...gridParams
                }
            );

            if(usersResponse.status === 401)
            {
                yield put(unauthorized(undefined));
                return;     
            }
            
            if(usersResponse.status !== 200)
                throw new Error("Error communicating with Api");

            yield put(usersSearchSlice.actions.setUsers(usersResponse.data.users));
            if(isLoading)
                yield put(usersSearchSlice.actions.setState('READY'));
        }
        catch(e: any){
            toast.error('Unable to load users.');
            console.log(`[UsersSagas:loadUsers] the following exception has occurred`, e);
            if(isLoading)
                yield put(usersSearchSlice.actions.setState('READY'));
        }
    }

    private static* debounceFilterUsers(){
        try {

            /*
                over-engineered but, debounce the api calls for searching
                debounces for 1s from the last search and cancels the debounce if a loadOrders action
                gets sent through the middleware.
            */
            while(true){
                yield take(filterUsers);
                yield put(usersSearchSlice.actions.setState('BUSY'));
                const [_, runFilter] = yield race([
                    take(loadUsers),
                    delay(1000),
                ]);

                if(runFilter){
                    yield put(loadUsers());
                }
                yield put(usersSearchSlice.actions.setState('READY'));
            }
        }
        catch(e: any){
            console.log(e);
        }
    }
}